import { render, staticRenderFns } from "./QuestionDialog.vue?vue&type=template&id=25ce1473&scoped=true"
import script from "./QuestionDialog.vue?vue&type=script&lang=js"
export * from "./QuestionDialog.vue?vue&type=script&lang=js"
import style0 from "./QuestionDialog.vue?vue&type=style&index=0&id=25ce1473&prod&lang=css"
import style1 from "./QuestionDialog.vue?vue&type=style&index=1&id=25ce1473&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ce1473",
  null
  
)

export default component.exports